import script from "./BorneAndroid.vue?vue&type=script&setup=true&lang=js"
export * from "./BorneAndroid.vue?vue&type=script&setup=true&lang=js"

import "./BorneAndroid.vue?vue&type=style&index=0&id=351f0cde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-351f0cde"]])

export default __exports__